var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../auth";
import { PersonaPathEnum, } from "@/shared/domain/entities/entity-persona";
export var ProductContext = React.createContext({
    loading: true,
    currentSkus: {
        otherSubscriptions: [],
        possiblesCrossSell: [],
        softwares: [],
    },
    entityProductsPlatforms: [],
    entityWalletPlatforms: [],
});
export var ProductProvider = function (_a) {
    var _b;
    var children = _a.children, contractDatasource = _a.contractDatasource, entityDatasource = _a.entityDatasource;
    var clientWallets = useContext(AuthContext).clientWallets;
    var clientRockId = (_b = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _b === void 0 ? void 0 : _b.rockId;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState({
        otherSubscriptions: [],
        possiblesCrossSell: [],
        softwares: [],
    }), currentSkus = _d[0], setCurrentSkus = _d[1];
    var _e = useState([]), entityProductsPlatforms = _e[0], setEntityProductsPlatforms = _e[1];
    var _f = useState([]), entityWalletPlatforms = _f[0], setEntityWalletPlatforms = _f[1];
    var removePossibleCrossSell = function (currentSkus) {
        var productsToRemove = ["iclips", "studio 2.0"];
        var possiblesCrossSell = currentSkus.possiblesCrossSell.filter(function (possibleCrossSell) {
            return !productsToRemove.includes(possibleCrossSell.description.toLowerCase());
        });
        return __assign(__assign({}, currentSkus), { possiblesCrossSell: possiblesCrossSell });
    };
    var requestCurrentSkus = function () {
        setLoading(true);
        contractDatasource
            .getCurrentSkus(clientRockId)
            .then(function (data) {
            setCurrentSkus(removePossibleCrossSell(data));
        })
            .finally(function () { return setLoading(false); });
    };
    var requestEntityProductsPlatforms = function () {
        setLoading(true);
        entityDatasource
            .getPersonaPlatforms(clientRockId, PersonaPathEnum.clients)
            .then(function (data) {
            setEntityProductsPlatforms(data);
        })
            .finally(function () { return setLoading(false); });
    };
    var requestEntityProductsFromWallet = function () { return __awaiter(void 0, void 0, void 0, function () {
        var products, _i, clientWallets_1, wallet, platforms, filteredPlatforms;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    products = [];
                    setLoading(true);
                    _i = 0, clientWallets_1 = clientWallets;
                    _a.label = 1;
                case 1:
                    if (!(_i < clientWallets_1.length)) return [3 /*break*/, 4];
                    wallet = clientWallets_1[_i];
                    setLoading(true);
                    return [4 /*yield*/, entityDatasource.getPersonaPlatforms(wallet.rockId, PersonaPathEnum.clients)];
                case 2:
                    platforms = _a.sent();
                    filteredPlatforms = platforms.filter(function (item) { return item.externalId; });
                    products.push.apply(products, filteredPlatforms);
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    setEntityWalletPlatforms(products);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!clientRockId)
            return;
        requestCurrentSkus();
        requestEntityProductsPlatforms();
    }, [clientRockId]);
    useEffect(function () {
        if (!clientRockId)
            return;
        requestEntityProductsFromWallet();
    }, [clientRockId, clientWallets]);
    return (React.createElement(ProductContext.Provider, { value: {
            loading: loading,
            currentSkus: currentSkus,
            entityProductsPlatforms: entityProductsPlatforms,
            entityWalletPlatforms: entityWalletPlatforms,
        } }, children));
};
